import { render, staticRenderFns } from "./MySubject.vue?vue&type=template&id=7b146206"
import script from "./MySubject.vue?vue&type=script&lang=js"
export * from "./MySubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports